import React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { useTheme } from "@mui/material/styles";
import { Link } from "react-router-dom";
import { styled } from "styled-components";
import { brandSettings } from "../../store/nanostore";
import { useStore } from "@nanostores/react";

interface StepperProps {
  steps: { path?: string | undefined; label: string }[];
  activeStep: number;
  onClick: (index: number) => void;
}
const StepperComponent: React.FC<StepperProps> = ({
  steps,
  activeStep,
  onClick,
}) => {
  const $brandSettings = useStore(brandSettings);
  const theme = useTheme();
  console.log("activeStep", activeStep);
  return (
    <>
      <Box
        sx={{
          maxWidth: "474px",
          width: "100%",
          [theme.breakpoints.down("sm")]: {
            overflowX: "auto",
            "&::-webkit-scrollbar": {
              display: "none",
            },
          },
        }}
      >
        <Stepper
          activeStep={activeStep}
          alternativeLabel
          sx={[
            {
              "& .Mui-active .MuiSvgIcon-root": {
                color: $brandSettings?.primaryColor,
              },
              "& .Mui-active .MuiSvgIcon-text": {
                color: $brandSettings?.secondaryColor,
              },
            },
          ]}
        >
          {steps.map((step, index) => (
            <Step key={index}>
              <LinkStyle
                // to={index <= activeStep ? step.path : "#"}
                to={step.path ? (index <= activeStep ? step.path : "#") : "#"}
                onClick={() =>
                  onClick(index <= activeStep ? index : activeStep)
                }
              >
                <StepLabel>{step.label}</StepLabel>
              </LinkStyle>
            </Step>
          ))}
        </Stepper>
      </Box>
    </>
  );
};

export const LinkStyle = styled(Link)`
  text-decoration: none;
`;

export default StepperComponent;
